import { render, staticRenderFns } from "./standardContract.vue?vue&type=template&id=b7cb09c4&scoped=true"
import script from "./standardContract.vue?vue&type=script&lang=js"
export * from "./standardContract.vue?vue&type=script&lang=js"
import style0 from "./standardContract.vue?vue&type=style&index=0&id=b7cb09c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cb09c4",
  null
  
)

export default component.exports